import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'page-header-from-to-filter',
  templateUrl: './page-header-from-to-filter.component.html',
  styleUrls: ['./page-header-from-to-filter.component.scss']
})
export class PageHeaderFromToFilterComponent implements OnInit {
  @Input() startDate: Date;
  @Input() endDate: Date;
  @Output() filterEvent:EventEmitter<any> = new EventEmitter<any>();
  @Output() actionEvent:EventEmitter<any> = new EventEmitter<any>();
  @Input() cardCategory: string;
  @Input() cardTitle: string;
  @Input() actionTitle: string;
  @Input() withAction: boolean = true;


  constructor() { }

  ngOnInit() {
  }

  filter() {
    this.filterEvent.emit({startDate:this.startDate, endDate:this.endDate});
  }

  action() {
    this.actionEvent.emit();
  }
}
